import styles from "./CriarEstabelecimento.module.css";
import { Link, useNavigate } from 'react-router-dom';
import Input from "../../../shared/form/Input";
import Select from "../../../shared/form/Select";
import { useState, useEffect } from 'react';
import { getArea, navigateToArea } from '../../../shared/utils/subdomain';

const SEGMENTOS = [
    { valor: 'pizzaria', label: '🍕 Pizzaria' },
    { valor: 'hamburgueria', label: '🍔 Hamburgueria' },
    { valor: 'lanchonete', label: '🥪 Lanchonete' },
    { valor: 'restaurante', label: '🍽 Restaurante' },
    { valor: 'outro', label: '🏪 Outro' }
];

function CriarEstabelecimento() {
    const [nomeEstabelecimento, setNomeEstabelecimento] = useState('');
    const [endereco, setEndereco] = useState('');
    const [telefone, setTelefone] = useState('');
    const [segmento, setSegmento] = useState('');
    const [universidades, setUniversidades] = useState([]);
    const [idUniversidade, setIdUniversidade] = useState('');
    const [nomeNovaUniversidade, setNomeNovaUniversidade] = useState('');

    const navigate = useNavigate();

    // 'unieat' = Lanchonete Universitária (mostra Universidade) | 'eatorder' = Restaurante (não mostra)
    // Usa o que sobrou da tela "Qual é o tipo do seu estabelecimento?" (primeiro
    // cadastro) só como valor inicial — quem já está logado e cria uma loja nova
    // pelo painel (botão "Criar loja") cai direto aqui sem passar por aquela
    // tela, então o tipo precisa poder ser escolhido/trocado neste formulário.
    const [tipoEstabelecimento, setTipoEstabelecimento] = useState(
        () => localStorage.getItem("tipo_estabelecimento") || ''
    );
    const isRestaurante = tipoEstabelecimento === 'eatorder';

    const escolherTipoEstabelecimento = (tipo) => {
        setTipoEstabelecimento(tipo);
        localStorage.setItem("tipo_estabelecimento", tipo);
    };

    // Buscar TODAS as universidades (não filtradas por admin)
    useEffect(() => {
        if (isRestaurante) return;

        const fetchUniversidades = async () => {
            try {
                const API_URL = process.env.REACT_APP_API_URL;
                const adminId = localStorage.getItem("admin_id");

                console.log("🔍 Admin ID:", adminId);
                console.log("🔍 API URL:", API_URL);

                if (!adminId) {
                    console.warn("⚠️ Admin ID não encontrado no localStorage");
                    return;
                }

                // Buscar TODAS as universidades, não apenas as do admin
                const url = `${API_URL}/universidades`;
                console.log("🔍 Buscando TODAS as universidades na URL:", url);

                const response = await fetch(url);
                console.log("📡 Response status:", response.status);

                if (response.ok) {
                    const data = await response.json();
                    console.log("✅ Universidades recebidas:", data);
                    console.log("📊 Quantidade de universidades:", data.length);
                    setUniversidades(data);
                } else {
                    console.error("❌ Erro na resposta:", response.status, response.statusText);
                }
            } catch (error) {
                console.error("❌ Erro ao buscar universidades:", error);
            }
        };

        fetchUniversidades();
    }, [isRestaurante]);



    const criacaoLoja = async (e) => {
        e.preventDefault();

        if (!nomeEstabelecimento || !endereco || !telefone) {
            alert("Todos os campos são obrigatórios!");
            return;
        }

        if (!tipoEstabelecimento) {
            alert("Selecione o tipo do estabelecimento (Restaurante ou Lanchonete Universitária).");
            return;
        }

        if (!segmento) {
            alert("Selecione a categoria do estabelecimento (Pizzaria, Hamburgueria, etc).");
            return;
        }

        try {
            const API_URL = process.env.REACT_APP_API_URL; // pega a URL do backend do .env
            const token = localStorage.getItem("token");

            if (!token) {
                console.error("Token não encontrado no localStorage");
                alert("Erro: você precisa estar logado como administrador.");
                return;
            }

            const response = await fetch(`${API_URL}/cadastroestabelecimento`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    nomeEstabelecimento,
                    endereco,
                    telefone,
                    segmento,
                    id_universidade: isRestaurante ? null : (idUniversidade || null),
                    nome_universidade: isRestaurante ? null : (nomeNovaUniversidade || null),
                    tipo_estabelecimento: tipoEstabelecimento
                })
            });

            const data = await response.json();

            if (response.ok) {
                console.log("Estabelecimento cadastrado com sucesso!", data.id_estabelecimento);
                localStorage.setItem("estabelecimento_id", data.id_estabelecimento);
                localStorage.setItem("nomeEstabelecimento", nomeEstabelecimento);

                if (getArea() === null) {
                    // Dev/preview sem subdomínio: segue direto pro painel com o token já salvo
                    navigate("/admin/gestaoestabelecimento");
                } else {
                    // Produção: painel do admin fica em outro subdomínio, precisa logar lá
                    alert("Estabelecimento criado com sucesso! Faça login para acessar o painel.");
                    navigateToArea(navigate, "admin", "/home");
                }
            } else {
                console.error("Erro ao cadastrar o estabelecimento:", data.error || data.message);
                alert(`Erro: ${data.error || "Não foi possível cadastrar o estabelecimento"}`);
            }
        } catch (err) {
            console.error("Erro na requisição:", err);
            alert("Erro ao conectar com o servidor. Verifique se o backend está rodando.");
        }
    };
    
    return (
        <div className={styles.secaoprincipal}>
            <header className={styles.cabecalho_page}>
                <h2>Registre Seu Restaurante!</h2>
                <p>Preencha os detalhes abaixo e garanta seu espaço no nosso sistema.</p>
            </header>

            <form onSubmit={criacaoLoja} method="POST" className={styles.formulario}>
                <div className={styles.tipoEstabelecimento}>
                    <label>Tipo do estabelecimento:</label>
                    <div className={styles.tipoEstabelecimentoOpcoes}>
                        <button
                            type="button"
                            className={`${styles.tipoEstabelecimentoBtn} ${tipoEstabelecimento === 'eatorder' ? styles.tipoEstabelecimentoBtnAtivo : ''}`}
                            onClick={() => escolherTipoEstabelecimento('eatorder')}
                        >
                            🍽 Restaurante
                        </button>
                        <button
                            type="button"
                            className={`${styles.tipoEstabelecimentoBtn} ${tipoEstabelecimento === 'unieat' ? styles.tipoEstabelecimentoBtnAtivo : ''}`}
                            onClick={() => escolherTipoEstabelecimento('unieat')}
                        >
                            🎓 Lanchonete Universitária
                        </button>
                    </div>
                </div>

                <Input
                    type="text"
                    text="Digite o nome do estabelecimento: "
                    name="nome_estabelecimento"
                    placeholder="Nome do estabelecimento"
                    handleOnChange={(e) => setNomeEstabelecimento(e.target.value)}
                />

                <div className={styles.tipoEstabelecimento}>
                    <label>Categoria do estabelecimento:</label>
                    <div className={styles.tipoEstabelecimentoOpcoes}>
                        {SEGMENTOS.map((s) => (
                            <button
                                key={s.valor}
                                type="button"
                                className={`${styles.tipoEstabelecimentoBtn} ${segmento === s.valor ? styles.tipoEstabelecimentoBtnAtivo : ''}`}
                                onClick={() => setSegmento(s.valor)}
                            >
                                {s.label}
                            </button>
                        ))}
                    </div>
                </div>

                <Input
                    type="text"
                    text="Digite o endereço: "
                    name="endereco"
                    placeholder="Endereço completo"
                    handleOnChange={(e) => setEndereco(e.target.value)}
                />

                <Input
                    type="text"
                    text="Digite o telefone: "
                    name="telefone"
                    placeholder="Telefone"
                    handleOnChange={(e) => setTelefone(e.target.value)}
                />
                {!isRestaurante && (
                    <>
                        <Select
                            name="universidade"
                            text="Selecione a Universidade:"
                            options={universidades.map(u => ({
                                id: u.id_universidade,
                                nome: `${u.nome}${u.sigla ? ` (${u.sigla})` : ''}`
                            }))}
                            handleOnChange={(e) => setIdUniversidade(e.target.value)}
                            value={idUniversidade}
                        />
                        <p className={styles.naoEncontrou}>Não Encontrou? Digite aqui</p>

                        <Input
                            type="text"
                            text="Digite o nome da universidade:"
                            name="nome_universidade"
                            placeholder="Nome da universidade"
                            handleOnChange={(e) => setNomeNovaUniversidade(e.target.value)}
                        />
                    </>
                )}

                <button className={styles.btn} type="submit">Cadastrar</button>
            </form>

           
        </div>
    );
}

export default CriarEstabelecimento;
